import React from 'react';

export default function DatasetTypeToggle({ value, onChange }) {
  return (
    <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
      {[
        { key: 'admission', label: 'Hospital Admission' },
        { key: 'trial', label: 'Clinical Trial Subject' },
      ].map(({ key, label }) => (
        <button
          key={key}
          className={value === key ? 'active' : ''}
          onClick={() => onChange(key)}
          style={{
            padding: '8px 18px',
            borderRadius: 6,
            border: '1px solid #1976d2',
            background: value === key ? '#1976d2' : '#fff',
            color: value === key ? '#fff' : '#1976d2',
            cursor: 'pointer',
            fontWeight: value === key ? 600 : 400,
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
